/* Elegance Coque — parcours d'achat.
   Barre « Mon iPhone », reprise du modèle entre catégories, aide « Je ne connais pas mon modèle »,
   filtres (couleur, prix, caractéristiques réelles), commande WhatsApp (fiche + panier), alternatives en rupture,
   pack personnalisable, livraison claire et panier conservé, accessoires compatibles du panier, liens Accueil / Favoris.
   Ne crée aucune donnée : tout vient des produits, du panier et des réglages de la section « Parcours d'achat ». */
(function () {
  if (window.ECParcours) { return; }
  var d = document, W = window;
  var CFG = {};
  try { var cn = d.getElementById('ec-parcours-config'); if (cn) { CFG = JSON.parse(cn.textContent) || {}; } } catch (e) {}
  var WA = '';
  try { var wn = d.getElementById('ec-wa-config'); if (wn) { WA = (JSON.parse(wn.textContent) || {}).link || ''; } } catch (e) {}
  WA = String(WA || '').split('?')[0];
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
  var MAIN = d.getElementById('MainContent');
  var PT = ((MAIN && MAIN.getAttribute('data-template')) || '').split('.')[0];
  var SMOOTH = !(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var MODEL_OPT = 'Modèle iPhone';

  /* ---------- outils ---------- */
  function qa(r, s) { return [].slice.call((r || d).querySelectorAll(s)); }
  function esc(t) { var s = d.createElement('span'); s.textContent = t == null ? '' : String(t); return s.innerHTML; }
  function el(tag, cls, html) { var x = d.createElement(tag); if (cls) { x.className = cls; } if (html != null) { x.innerHTML = html; } return x; }
  function dh(c) {
    c = Math.round(Number(c) || 0); var neg = c < 0; if (neg) { c = -c; }
    var w = Math.floor(c / 100), r = c % 100;
    return (neg ? '-' : '') + String(w).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (r ? ',' + (r < 10 ? '0' : '') + r : '') + ' DH';
  }
  function cents(v) { if (typeof v === 'number') { return v; } var n = parseFloat(String(v || '0').replace(',', '.')); return Math.round((isNaN(n) ? 0 : n) * 100); }
  function getJSON(u) { return fetch(u, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { if (!r.ok) { throw new Error(String(r.status)); } return r.json(); }); }
  function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function optName(o) { return typeof o === 'string' ? o : (o && o.name) || ''; }
  function scrollTo(x) { if (!x) { return; } try { x.scrollIntoView({ behavior: SMOOTH ? 'smooth' : 'auto', block: 'center' }); } catch (e) { x.scrollIntoView(); } }
  function absUrl(p) { try { return new URL(p, location.origin).toString(); } catch (e) { return location.origin + p; } }
  function waOpen(msg) { if (!WA) { return false; } var u = WA + '?text=' + encodeURIComponent(msg); var w = W.open(u, '_blank', 'noopener'); if (!w) { location.href = u; } return true; }

  /* ---------- modèle mémorisé (même clé que le reste du thème : « ec-model ») ---------- */
  function readModel() {
    if (W.ECModel) { return W.ECModel.read(); }
    try { var v = W.localStorage.getItem('ec-model') || '', i = v.indexOf('|'); return i > 0 ? { handle: v.slice(0, i), label: v.slice(i + 1) } : null; } catch (e) { return null; }
  }
  function saveModel(m) {
    if (W.ECModel) { W.ECModel.save(m); return; }
    try { if (m) { W.localStorage.setItem('ec-model', m.handle + '|' + m.label); } else { W.localStorage.removeItem('ec-model'); } } catch (e) {}
    try { d.dispatchEvent(new CustomEvent('ec:model', { detail: m || null })); } catch (e) {}
  }
  function shortLabel(l) { return String(l || '').replace(/^\s*iphone\s*/i, ''); }
  function selBox() { return d.getElementById('choisir-iphone'); }
  /* bouton d'un sélecteur de section dont un attribut data-xxx-<suffix> vaut val (ecat, emrq, lmsel…) */
  function findCtl(box, suffix, val) {
    var hit = null;
    qa(box, 'button,a').some(function (b) {
      for (var i = 0; i < b.attributes.length; i++) {
        var a = b.attributes[i];
        if (/^data-[a-z0-9]+-/.test(a.name) && a.name.slice(-(suffix.length + 1)) === '-' + suffix && a.value === val) { hit = b; return true; }
      }
      return false;
    });
    return hit;
  }
  function attrMatch(b, re) { for (var i = 0; i < b.attributes.length; i++) { if (re.test(b.attributes[i].name)) { return b.attributes[i]; } } return null; }
  function urlHasModel() { try { var q = new URL(location.href).searchParams; return !!(q.get('modele') || q.get('serie') || q.get('model')); } catch (e) { return false; } }

  /* ===== 1. Barre « Mon iPhone : 16 Pro — Changer · Réinitialiser » ===== */
  var noteMiss = null;
  function renderBar() {
    if (!MAIN || PT === 'product' || PT === 'cart') { return; }
    var m = readModel(), bar = d.querySelector('[data-ecp-bar]');
    if (!m) { if (bar) { bar.parentNode.removeChild(bar); } return; }
    if (!bar) {
      bar = el('div', 'ecp-bar');
      bar.setAttribute('data-ecp-bar', '');
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Mon iPhone');
      MAIN.insertBefore(bar, MAIN.firstChild);
    }
    var openSheet = !selBox() && d.querySelector('[data-ecms]');
    bar.innerHTML = '<div class="ecp-bar__in"><p class="ecp-bar__t"><span class="ecp-bar__l">Votre modèle :</span> <b>iPhone ' + esc(shortLabel(m.label)) + '</b></p>' +
      '<span class="ecp-bar__sep" aria-hidden="true">·</span>' +
      '<button type="button" class="ecp-bar__b" data-ecp-change' + (openSheet ? ' data-ecms-open' : '') + ' aria-label="Modifier le modèle d’iPhone">Modifier</button>' +
      '<span class="ecp-bar__sep" aria-hidden="true">·</span>' +
      '<button type="button" class="ecp-bar__b ecp-bar__b--x" data-ecp-reset aria-label="Effacer le modèle d’iPhone">Effacer</button></div>' +
      (noteMiss ? '<p class="ecp-bar__n">' + esc(noteMiss) + '</p>' : '');
  }
  function changeModel() {
    var box = selBox(), m = readModel();
    if (box) {
      scrollTo(box);
      if (m) {
        var ser = shortLabel(m.label).split(' ')[0].replace(/\/.*/, '');
        var sb = findCtl(box, 'ser', ser);
        if (sb && sb.getAttribute('aria-expanded') === 'false') { sb.click(); }
      }
      return;
    }
    location.href = (CFG.all_url || ROOT + 'collections/toutes-les-coques');
  }
  function resetModel() {
    saveModel(null);
    noteMiss = null;
    try {
      var u = new URL(location.href);
      if (u.searchParams.get('modele') || u.searchParams.get('serie')) { u.searchParams.delete('modele'); u.searchParams.delete('serie'); location.replace(u.toString()); return; }
    } catch (e) {}
    var box = selBox();
    if (box) {
      var clr = qa(box, 'button').filter(function (b) { var a = attrMatch(b, /^data-[a-z0-9]+-(clear|reset)$/); var s = attrMatch(b, /^data-[a-z0-9]+-ser$/); return a || (s && s.value === ''); })[0];
      if (clr) { clr.click(); }
    }
    renderBar();
  }

  /* ===== 2. Reprise du modèle sur les pages de catégorie (jamais au tout premier passage : rien n'est mémorisé) ===== */
  function restoreModel() {
    if (PT !== 'collection' || urlHasModel()) { return; }
    var m = readModel(), box = selBox();
    if (!m || !box) { return; }
    var mb = findCtl(box, 'm', m.handle);
    if (!mb) {
      var hasSel = qa(box, 'button').some(function (b) { return attrMatch(b, /^data-[a-z0-9]+-m$/); });
      if (hasSel) { noteMiss = 'Aucun produit compatible avec votre iPhone ' + shortLabel(m.label) + ' dans cette rubrique pour le moment : toute la rubrique est affichée.'; }
      return;
    }
    if (mb.getAttribute('aria-pressed') === 'true') { return; }
    var ser = attrMatch(mb, /^data-[a-z0-9]+-m$/).value.replace(/^iphone-/, '').split('-')[0];
    var sb = findCtl(box, 'ser', ser);
    if (sb && sb.getAttribute('aria-expanded') !== 'true' && sb.getAttribute('aria-pressed') !== 'true') { sb.click(); }
    mb.click();
  }
  /* « Tous les modèles », « Tous », ou un 2e appui sur le modèle actif : le choix mémorisé est effacé aussi */
  d.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) { return; }
    if (t.closest('[data-ecp-change]')) { if (!t.closest('[data-ecp-change]').hasAttribute('data-ecms-open')) { e.preventDefault(); changeModel(); } return; }
    if (t.closest('[data-ecp-reset]')) { e.preventDefault(); resetModel(); return; }
    var b = t.closest('button'); if (!b || !b.closest('[data-ecat],[data-emrq],#choisir-iphone,[class*="__empty"]')) { return; }
    var clr = attrMatch(b, /^data-[a-z0-9]+-(clear|reset)$/), ser = attrMatch(b, /^data-[a-z0-9]+-ser$/), mod = attrMatch(b, /^data-[a-z0-9]+-m$/);
    if (clr || (ser && ser.value === '') || (mod && b.getAttribute('aria-pressed') === 'true')) {
      saveModel(null); noteMiss = null;
    }
    W.setTimeout(refreshFilters, 30);
  }, true);
  d.addEventListener('ec:model', function () { noteMiss = null; renderBar(); });
  W.addEventListener('storage', function (e) { if (e.key === 'ec-model') { renderBar(); } });

  /* ===== 3. « Je ne connais pas mon modèle » ===== */
  var helpDlg = null, helpFrom = null;
  function helpDialog() {
    if (helpDlg) { return helpDlg; }
    helpDlg = el('dialog', 'ecp-help');
    helpDlg.setAttribute('aria-labelledby', 'ecp-help-t');
    helpDlg.innerHTML = '<h2 class="ecp-help__t" id="ecp-help-t">Trouver votre modèle d’iPhone</h2>' +
      '<p class="ecp-help__p">Sur votre iPhone, ouvrez :</p>' +
      '<p class="ecp-help__path"><span>Réglages</span><i aria-hidden="true">→</i><span>Général</span><i aria-hidden="true">→</i><span>Informations</span><i aria-hidden="true">→</i><span>Nom du modèle</span></p>' +
      '<p class="ecp-help__p">Choisissez ensuite exactement ce nom (par exemple « iPhone 16 Pro »).</p>' +
      '<button type="button" class="ecp-help__ok" data-ecp-help-close>Fermer et reprendre ma sélection</button>';
    d.body.appendChild(helpDlg);
    helpDlg.addEventListener('click', function (e) { if (e.target === helpDlg || (e.target.closest && e.target.closest('[data-ecp-help-close]'))) { closeHelp(); } });
    helpDlg.addEventListener('cancel', function (e) { e.preventDefault(); closeHelp(); });
    return helpDlg;
  }
  function openHelp(from) {
    var g = helpDialog(); helpFrom = from || null;
    if (g.showModal) { g.showModal(); } else { g.setAttribute('open', ''); }
    var ok = g.querySelector('[data-ecp-help-close]'); if (ok) { ok.focus(); }
  }
  function closeHelp() {
    if (!helpDlg) { return; }
    if (helpDlg.close) { helpDlg.close(); } else { helpDlg.removeAttribute('open'); }
    if (helpFrom) { try { helpFrom.focus({ preventScroll: true }); } catch (e) {} scrollTo(helpFrom.closest('#choisir-iphone') || helpFrom); }
  }
  function helpLink() { var b = el('button', 'ecp-helplink', 'Je ne connais pas mon modèle'); b.type = 'button'; b.setAttribute('data-ecp-help', ''); return b; }
  function addHelpLinks() {
    qa(d, '#choisir-iphone').forEach(function (box) {
      if (box.querySelector('[data-ecp-help]')) { return; }
      var wrap = el('p', 'ecp-helpwrap'); wrap.appendChild(helpLink());
      var lm = box.querySelector('[data-lmsel]');
      (lm && lm !== box ? lm : box).appendChild(wrap);
    });
    if (PT === 'product') {
      var r = d.querySelector('#MainContent input[type=radio][data-option-name="' + MODEL_OPT + '"]');
      if (r && !d.querySelector('#MainContent [data-ecp-help]')) {
        var g = r.closest('fieldset') || r.parentElement;
        var w2 = el('p', 'ecp-helpwrap ecp-helpwrap--pdp'); w2.appendChild(helpLink());
        g.parentNode.insertBefore(w2, g.nextSibling);
      }
    }
  }
  d.addEventListener('click', function (e) { var b = e.target && e.target.closest ? e.target.closest('[data-ecp-help]') : null; if (b) { e.preventDefault(); openHelp(b); } });

  /* ===== 4. Filtres (modèle, couleur, prix, disponibilité, caractéristiques) sur les grilles de catégorie =====
     Uniquement des données réelles : options et prix des variantes, titres/étiquettes, MagSafe seulement s'il est
     coché sur la fiche (métachamp « Compatible MagSafe »). Les filtres choisis sont gardés pendant la visite. */
  var FEATS = [
    ['support', 'Avec support', /\bsupport\b/i],
    ['porte-cartes', 'Avec porte-cartes', /porte[\s-]?cartes?/i],
    ['transparente', 'Transparent', /transparent/i],
    ['magsafe', 'MagSafe', null]
  ];
  var filterSets = [];
  var META = CFG.meta || {};
  function collHandle() { var m = location.pathname.match(/\/collections\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function handleOf(u) { var m = String(u || '').match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function facetsOf(p) {
    var opts = (p.options || []).map(optName), ci = -1, mi = -1;
    opts.forEach(function (n, i) { if (/^(couleur|color|colour)$/i.test(n)) { ci = i; } if (n === MODEL_OPT) { mi = i; } });
    var colors = {}, models = {}, min = Infinity, avail = false;
    (p.variants || []).forEach(function (v) {
      var pr = cents(v.price); if (pr > 0 && pr < min) { min = pr; }
      if (v.available) { avail = true; }
      if (ci > -1) { var c = v['option' + (ci + 1)] || (v.options && v.options[ci]); if (c) { colors[norm(c)] = c; } }
      if (mi > -1) { var mv = v['option' + (mi + 1)] || (v.options && v.options[mi]); var em = mv && W.ECModel ? W.ECModel.fromValue(mv) : null; if (em) { models[em.handle] = em.label; } }
    });
    if (mi < 0) { (p.tags || []).forEach(function (t) { if (/^iphone\s/i.test(t) && W.ECModel) { var em = W.ECModel.fromValue(String(t).replace(/^iphone\s*/i, '')); if (em) { models[em.handle] = em.label; } } }); }
    var hay = p.title + ' ' + (p.tags || []).join(' ');
    var feats = {};
    FEATS.forEach(function (f) { if (f[2] ? f[2].test(hay) : (f[0] === 'magsafe' && META[p.handle] && META[p.handle].magsafe)) { feats[f[0]] = 1; } });
    return { colors: colors, models: models, price: min === Infinity ? 0 : min, avail: avail, feats: feats };
  }
  function setupFilters() {
    if (PT !== 'collection') { return; }
    var grids = qa(d, '#MainContent ul').filter(function (u) { return !u.__ecpf && u.querySelector('.lcard[data-url][data-m]'); });
    if (!grids.length) { return; }
    var h = collHandle(); if (!h) { return; }
    grids.forEach(function (u) { u.__ecpf = true; });
    getJSON(ROOT + 'collections/' + encodeURIComponent(h) + '/products.json?limit=250').then(function (j) {
      var map = {}; (j.products || []).forEach(function (p) { map[p.handle] = facetsOf(p); });
      grids.forEach(function (ul) { buildFilters(ul, map); });
    }).catch(function () {});
  }
  function pageModelBtn(handle) { var box = selBox(); return box ? findCtl(box, 'm', handle) : null; }
  function selectPageModel(handle) {
    var mb = pageModelBtn(handle); if (!mb) { return false; }
    if (mb.getAttribute('aria-pressed') === 'true') { return true; }
    var sb = findCtl(selBox(), 'ser', handle.replace(/^iphone-/, '').split('-')[0]);
    if (sb && sb.getAttribute('aria-expanded') !== 'true' && sb.getAttribute('aria-pressed') !== 'true') { sb.click(); }
    mb.click(); return true;
  }
  function buildFilters(ul, map) {
    var cards = qa(ul, '.lcard[data-url]');
    var data = cards.map(function (li) { return { el: li, f: map[handleOf(li.getAttribute('data-url'))] || null }; }).filter(function (x) { return x.f; });
    if (data.length < 2) { return; }
    var colors = {}, models = {}, prices = {}, fc = {}, soldout = 0;
    data.forEach(function (x) {
      Object.keys(x.f.colors).forEach(function (k) { colors[k] = colors[k] || x.f.colors[k]; });
      Object.keys(x.f.models).forEach(function (k) { models[k] = models[k] || x.f.models[k]; });
      if (x.f.price) { prices[x.f.price] = 1; }
      if (!x.f.avail) { soldout++; }
      Object.keys(x.f.feats).forEach(function (k) { fc[k] = (fc[k] || 0) + 1; });
    });
    var colorKeys = Object.keys(colors).sort(function (a, b) { return colors[a].localeCompare(colors[b], 'fr'); });
    var modelKeys = Object.keys(models).sort(function (a, b) { return models[b].localeCompare(models[a], 'fr', { numeric: true }); });
    var priceList = Object.keys(prices).map(Number).sort(function (a, b) { return a - b; });
    var feats = FEATS.filter(function (f) { return fc[f[0]] > 0 && fc[f[0]] < data.length; });
    var groups = [];
    if (modelKeys.length > 1) { groups.push({ k: 'm', t: 'Modèle', items: modelKeys.map(function (k) { return [k, models[k]]; }) }); }
    if (colorKeys.length > 1) { groups.push({ k: 'c', t: 'Couleur', items: colorKeys.map(function (k) { return [k, colors[k]]; }) }); }
    if (priceList.length > 1) { groups.push({ k: 'p', t: 'Prix', items: priceList.slice(0, -1).map(function (p) { return [String(p), 'Jusqu’à ' + dh(p)]; }) }); }
    if (soldout > 0 && soldout < data.length) { groups.push({ k: 'a', t: 'Disponibilité', items: [['1', 'En stock uniquement']] }); }
    if (feats.length) { groups.push({ k: 'f', t: 'Caractéristiques', items: feats.map(function (f) { return [f[0], f[1]]; }) }); }
    if (!groups.length) { return; }

    var KEY = 'ecpf:' + location.pathname;
    var st = { m: '', c: {}, p: '', a: '', f: {} };
    try { var sv = JSON.parse(W.sessionStorage.getItem(KEY) || 'null'); if (sv) { st.c = sv.c || {}; st.p = sv.p || ''; st.a = sv.a || ''; st.f = sv.f || {}; st.m = sv.m || ''; } } catch (e) {}
    var box = el('div', 'ecp-f'); box.setAttribute('data-ecp-f', '');
    var html = '<div class="ecp-f__row">';
    groups.forEach(function (g) {
      html += '<details class="ecp-f__g" data-g="' + g.k + '"><summary class="ecp-f__s">' + g.t + '<span class="ecp-f__n" data-n></span></summary><div class="ecp-f__pn" role="group" aria-label="' + g.t + '">';
      g.items.forEach(function (it) { html += '<button type="button" class="ecp-f__o" data-k="' + g.k + '" data-v="' + esc(it[0]) + '" aria-pressed="false">' + esc(it[1]) + '</button>'; });
      html += '</div></details>';
    });
    html += '</div><div class="ecp-f__act" data-act hidden></div><p class="ecp-f__res" data-res aria-live="polite"></p><div class="ecp-f__empty" data-emp hidden></div>';
    box.innerHTML = html;
    var anchor = ul.previousElementSibling && ul.previousElementSibling.querySelector && ul.previousElementSibling.querySelector('select') ? ul.previousElementSibling : ul;
    ul.parentNode.insertBefore(box, anchor);
    var act = box.querySelector('[data-act]'), res = box.querySelector('[data-res]'), emp = box.querySelector('[data-emp]');
    function pageModel() { try { return (new URL(location.href).searchParams.get('modele') || '').toLowerCase(); } catch (e) { return ''; } }
    function curModel() { return pageModel() || st.m; }
    function save() { try { W.sessionStorage.setItem(KEY, JSON.stringify({ m: st.m, c: st.c, p: st.p, a: st.a, f: st.f })); } catch (e) {} }
    function apply() {
      var n = 0, any = false, cm = curModel();
      data.forEach(function (x) {
        var ok = true, cs = Object.keys(st.c);
        if (st.m && !x.f.models[st.m]) { ok = false; }
        if (ok && cs.length) { ok = cs.some(function (c) { return x.f.colors[c]; }); }
        if (ok && st.p) { ok = x.f.price > 0 && x.f.price <= Number(st.p); }
        if (ok && st.a) { ok = x.f.avail; }
        if (ok) { Object.keys(st.f).forEach(function (k) { if (!x.f.feats[k]) { ok = false; } }); }
        x.el.classList.toggle('ecp-out', !ok);
        if (ok && !x.el.hidden) { n++; }
      });
      var chips = '';
      if (cm) { var ml = models[cm] || (W.ECModel && W.ECModel.fromHandle(cm) ? W.ECModel.fromHandle(cm).label : cm); chips += '<button type="button" class="ecp-f__chip" data-x="m">' + esc(ml) + '</button>'; }
      Object.keys(st.c).forEach(function (c) { any = true; chips += '<button type="button" class="ecp-f__chip" data-x="c" data-v="' + esc(c) + '">' + esc(colors[c] || c) + '</button>'; });
      if (st.p) { any = true; chips += '<button type="button" class="ecp-f__chip" data-x="p">Jusqu’à ' + esc(dh(Number(st.p))) + '</button>'; }
      if (st.a) { any = true; chips += '<button type="button" class="ecp-f__chip" data-x="a">En stock</button>'; }
      Object.keys(st.f).forEach(function (k) { any = true; var f = FEATS.filter(function (x) { return x[0] === k; })[0]; chips += '<button type="button" class="ecp-f__chip" data-x="f" data-v="' + k + '">' + esc(f ? f[1] : k) + '</button>'; });
      var filtered = any || !!cm;
      if (filtered) { chips += '<button type="button" class="ecp-f__clear" data-clear>Effacer les filtres</button>'; }
      act.innerHTML = chips; act.hidden = !chips;
      res.textContent = filtered ? (n + ' résultat' + (n > 1 ? 's' : '')) : '';
      var showEmpty = filtered && !n;
      emp.hidden = !showEmpty;
      if (showEmpty) {
        var allU = (CFG.all_url || ROOT + 'collections/toutes-les-coques') + (cm ? '?modele=' + encodeURIComponent(cm) : '');
        emp.innerHTML = '<p>Aucun produit ne correspond à ces filtres pour le moment.</p><p class="ecp-f__acts"><button type="button" class="ecp-f__lnk" data-edit>Modifier les filtres</button><a class="ecp-f__lnk" href="' + esc(allU) + '">' + (cm ? 'Voir les autres coques compatibles' : 'Voir toutes les coques') + '</a></p>';
      }
      qa(box, '.ecp-f__o').forEach(function (b) {
        var k = b.getAttribute('data-k'), v = b.getAttribute('data-v');
        var on = k === 'm' ? cm === v : k === 'c' ? !!st.c[v] : k === 'p' ? st.p === v : k === 'a' ? !!st.a : !!st.f[v];
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      qa(box, '.ecp-f__g').forEach(function (g) {
        var k = g.getAttribute('data-g'), c = k === 'm' ? (cm ? 1 : 0) : k === 'c' ? Object.keys(st.c).length : k === 'p' ? (st.p ? 1 : 0) : k === 'a' ? (st.a ? 1 : 0) : Object.keys(st.f).length;
        var nn = g.querySelector('[data-n]'), tx = c ? ' (' + c + ')' : ''; if (nn.textContent !== tx) { nn.textContent = tx; }
      });
      save();
    }
    function setModel(v) {
      if (!v) { st.m = ''; if (pageModel()) { clearPageModel(); } return; }
      if (selectPageModel(v)) { st.m = ''; } else { st.m = st.m === v ? '' : v; if (st.m && W.ECModel) { var em = W.ECModel.fromHandle(st.m); if (em) { saveModel(em); } } }
    }
    box.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) { return; }
      var o = t.closest('.ecp-f__o');
      if (o) {
        var k = o.getAttribute('data-k'), v = o.getAttribute('data-v');
        if (k === 'm') { setModel(curModel() === v ? '' : v); }
        else if (k === 'c') { if (st.c[v]) { delete st.c[v]; } else { st.c[v] = 1; } }
        else if (k === 'p') { st.p = st.p === v ? '' : v; }
        else if (k === 'a') { st.a = st.a ? '' : '1'; }
        else { if (st.f[v]) { delete st.f[v]; } else { st.f[v] = 1; } }
        var dt = o.closest('details'); if (dt) { dt.open = false; }
        W.setTimeout(apply, 30); return;
      }
      var ch = t.closest('.ecp-f__chip');
      if (ch) {
        var x = ch.getAttribute('data-x'), cv = ch.getAttribute('data-v');
        if (x === 'c') { delete st.c[cv]; } else if (x === 'p') { st.p = ''; } else if (x === 'a') { st.a = ''; } else if (x === 'f') { delete st.f[cv]; } else if (x === 'm') { setModel(''); }
        W.setTimeout(apply, 30); return;
      }
      if (t.closest('[data-edit]')) { var g1 = box.querySelector('.ecp-f__g'); if (g1) { g1.open = true; scrollTo(box); } return; }
      if (t.closest('[data-clear]')) { st = { m: '', c: {}, p: '', a: '', f: {} }; if (pageModel()) { clearPageModel(); } W.setTimeout(apply, 30); }
    });
    box.addEventListener('toggle', function (e) { var g = e.target; if (g.open) { qa(box, '.ecp-f__g').forEach(function (o) { if (o !== g) { o.open = false; } }); } }, true);
    d.addEventListener('click', function (e) { if (!box.contains(e.target)) { qa(box, '.ecp-f__g[open]').forEach(function (o) { o.open = false; }); } });
    if (W.MutationObserver) { new MutationObserver(function () { W.clearTimeout(box.__t); box.__t = W.setTimeout(apply, 40); }).observe(ul, { attributes: true, attributeFilter: ['hidden'], subtree: true }); }
    filterSets.push(apply);
    apply();
    /* retour depuis une fiche : position dans la liste */
    try { var y = Number(W.sessionStorage.getItem('ecpy:' + location.pathname) || 0); if (y > 0 && performance && performance.getEntriesByType && (performance.getEntriesByType('navigation')[0] || {}).type === 'back_forward') { W.scrollTo(0, y); } } catch (e) {}
  }
  W.addEventListener('pagehide', function () { if (PT === 'collection') { try { W.sessionStorage.setItem('ecpy:' + location.pathname, String(W.scrollY || 0)); } catch (e) {} } });
  function clearPageModel() {
    saveModel(null);
    var box = selBox(); if (!box) { return; }
    var clr = qa(box, 'button').filter(function (b) { var a = attrMatch(b, /^data-[a-z0-9]+-(clear|reset)$/); var s = attrMatch(b, /^data-[a-z0-9]+-ser$/); return a || (s && s.value === ''); })[0];
    if (clr) { clr.click(); return; }
    var on = qa(box, 'button[aria-pressed="true"]').filter(function (b) { return attrMatch(b, /^data-[a-z0-9]+-m$/); })[0];
    if (on) { on.click(); }
  }
  function refreshFilters() { filterSets.forEach(function (f) { f(); }); }

  /* ===== Fiche produit : WhatsApp, alternatives en rupture, pack ===== */
  var P = null;
  function productForm() { return qa(d, '#MainContent form[action*="/cart/add"]').filter(function (f) { return !f.closest('[data-ecp-pack],.lca,[data-ec-qb],dialog'); })[0] || null; }
  function variantId(form) { var i = form && form.querySelector('[name="id"]'); return i ? Number(i.value) : 0; }
  function variantById(id) { return P ? (P.variants || []).filter(function (v) { return v.id === id; })[0] : null; }
  function optIndex(re) { var idx = -1; (P && P.options || []).forEach(function (o, i) { if (re.test(optName(o))) { idx = i; } }); return idx; }
  function missingOptions() {
    var names = [], seen = {};
    qa(d, '#MainContent input[type=radio][data-option-name]').forEach(function (r) {
      if (r.closest('[data-ecp-pack],.lca')) { return; }
      var n = r.getAttribute('data-option-name'); if (seen[n] !== undefined) { if (r.checked) { seen[n] = true; } return; }
      seen[n] = !!r.checked; names.push(n);
    });
    var miss = names.filter(function (n) { return !seen[n]; });
    if (W.LuxeModelGate && W.LuxeModelGate.hasModel() && !W.LuxeModelGate.isChosen() && miss.indexOf(MODEL_OPT) < 0) { miss.unshift(MODEL_OPT); }
    return miss;
  }
  function chosenModelValue() { var r = d.querySelector('#MainContent input[type=radio][data-option-name="' + MODEL_OPT + '"]:checked'); return r && (!W.LuxeModelGate || W.LuxeModelGate.isChosen()) ? r.value.trim() : ''; }
  function quantity() { var q = d.querySelector('#MainContent input[name="quantity"]'); var n = q ? parseInt(q.value, 10) : 1; return n > 0 ? n : 1; }
  function showMiss(msgEl, miss) {
    msgEl.textContent = 'Choisissez d’abord : ' + miss.join(', ') + '.';
    var r = d.querySelector('#MainContent input[type=radio][data-option-name="' + miss[0] + '"]');
    if (r) { scrollTo(r.closest('fieldset') || r); }
  }
  function variantLines(v) {
    var out = [], names = (P.options || []).map(optName);
    names.forEach(function (n, i) { var val = v.options ? v.options[i] : v['option' + (i + 1)]; if (val && val !== 'Default Title') { out.push([n, n === MODEL_OPT ? 'iPhone ' + val : val]); } });
    return out;
  }
  function setupProduct() {
    if (PT !== 'product') { return; }
    var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (!m) { return; }
    getJSON(ROOT + 'products/' + m[1] + '.js').then(function (p) {
      P = p; pushRecent(p); renderRecent(p.handle);
      var form = productForm(); if (!form) { return; }
      var host = form.closest('product-form-component') || form;
      var zone = el('div', 'ecp-pdp'); zone.setAttribute('data-ecp-pdp', '');
      host.parentNode.insertBefore(zone, host.nextSibling);
      if (WA) {
        var wa = el('div', 'ecp-wa', '<button type="button" class="ecp-wa__b" data-ecp-wa><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12.04 2a9.9 9.9 0 0 0-8.5 14.9L2 22l5.25-1.38A9.9 9.9 0 1 0 12.04 2zm0 1.8a8.1 8.1 0 1 1-4.17 15.05l-.3-.18-3.1.82.83-3.03-.2-.31A8.1 8.1 0 0 1 12.04 3.8z"/></svg>Commander sur WhatsApp</button><p class="ecp-wa__m" data-ecp-wa-msg role="status" aria-live="polite"></p>');
        zone.appendChild(wa);
      }
      var alt = el('div', 'ecp-alt'); alt.setAttribute('data-ecp-alt', ''); alt.hidden = true; alt.setAttribute('role', 'status'); zone.appendChild(alt);
      var pack = el('section', 'ecp-pack'); pack.setAttribute('data-ecp-pack', ''); pack.hidden = true; pack.setAttribute('aria-label', 'Composez votre pack'); zone.appendChild(pack);
      updateAlt(); setupPack(pack);
      /* les blocs de la fiche peuvent être redessinés au changement de variante : on remet la zone et l'aide en place */
      if (W.MutationObserver) {
        new MutationObserver(function () {
          W.clearTimeout(zone.__t);
          zone.__t = W.setTimeout(function () {
            if (!d.body.contains(zone)) { var f = productForm(); if (f) { var h2 = f.closest('product-form-component') || f; h2.parentNode.insertBefore(zone, h2.nextSibling); } }
            addHelpLinks(); packTotal();
          }, 150);
        }).observe(MAIN, { childList: true, subtree: true });
      }
      d.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('#MainContent input[type=radio]') && !e.target.closest('[data-ecp-pack]')) { W.setTimeout(function () { updateAlt(); renderPack(); }, 250); W.setTimeout(updateAlt, 700); } });
      d.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('[data-lmodel-change]')) { W.setTimeout(function () { updateAlt(); renderPack(); }, 120); } });
      addHelpLinks();
    }).catch(function () {});
  }
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ecp-wa]') : null; if (!b || !P) { return; }
    e.preventDefault();
    var msgEl = d.querySelector('[data-ecp-wa-msg]'); msgEl.textContent = '';
    var miss = missingOptions(); if (miss.length) { showMiss(msgEl, miss); return; }
    var v = variantById(variantId(productForm()));
    if (!v) { msgEl.textContent = 'Choisissez d’abord vos options.'; return; }
    if (!v.available) { msgEl.textContent = 'Cette version est épuisée : choisissez une autre couleur.'; return; }
    var qty = quantity(), lines = ['Bonjour Elegance Coque, je souhaite commander :', '', '• Produit : ' + P.title];
    variantLines(v).forEach(function (x) { lines.push('• ' + x[0] + ' : ' + x[1]); });
    lines.push('• Quantité : ' + qty);
    lines.push('• Prix : ' + dh(v.price) + (qty > 1 ? ' l’unité, soit ' + dh(v.price * qty) : ''));
    lines.push('• Lien : ' + absUrl(ROOT + 'products/' + P.handle + '?variant=' + v.id));
    lines.push('', 'Merci de me confirmer la commande.');
    if (!waOpen(lines.join('\n'))) { msgEl.textContent = 'La commande WhatsApp n’est pas disponible pour le moment.'; }
  });

  /* ===== 12. Variante épuisée : autres couleurs pour le MÊME iPhone, sans jamais changer le modèle ===== */
  function updateAlt() {
    var box = d.querySelector('[data-ecp-alt]'); if (!box || !P) { return; }
    var v = variantById(variantId(productForm()));
    var mi = optIndex(/^modèle iphone$/i), ci = optIndex(/^(couleur|color)$/i);
    if (!v || v.available || (mi > -1 && !chosenModelValue())) { box.hidden = true; box.innerHTML = ''; return; }
    var mv = mi > -1 ? v.options[mi] : null, seen = {};
    var others = (P.variants || []).filter(function (x) { return x.available && x.id !== v.id && (mi < 0 || x.options[mi] === mv); });
    var html = '<p class="ecp-alt__t">Cette version est épuisée' + (mv ? ' pour votre iPhone ' + esc(mv) : '') + '.</p>';
    if (others.length && ci > -1) {
      html += '<p class="ecp-alt__s">Disponible pour le même iPhone :</p><div class="ecp-alt__row">';
      others.forEach(function (x) { var c = x.options[ci]; if (seen[c]) { return; } seen[c] = 1; html += '<button type="button" class="ecp-alt__o" data-ecp-color="' + esc(c) + '">' + esc(c) + '</button>'; });
      html += '</div>';
    }
    if (mv && W.ECModel) {
      var em = W.ECModel.fromValue(mv), colls = {};
      try { colls = JSON.parse((d.querySelector('[data-lmf-colls]') || {}).textContent || '{}'); } catch (e) {}
      var c2 = em && colls[W.ECModel.collHandle(em)];
      if (c2 && c2.count > 1) { html += '<a class="ecp-alt__l" href="' + esc(c2.url) + '">Voir d’autres coques pour iPhone ' + esc(mv) + '</a>'; }
    }
    box.innerHTML = html; box.hidden = false;
  }
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ecp-color]') : null; if (!b) { return; }
    var c = b.getAttribute('data-ecp-color');
    var r = qa(d, '#MainContent input[type=radio][data-option-name]').filter(function (x) { return /^(couleur|color)$/i.test(x.getAttribute('data-option-name')) && x.value.trim() === c; })[0];
    if (r) { r.click(); W.setTimeout(updateAlt, 400); }
  });

  /* ===== 7. Pack personnalisable : la coque + un article facultatif par rubrique (incassable, cache caméra, bandoulière)
     Rubriques et collections réglées dans la section « Parcours d'achat ». Seuls les articles en vente, à prix > 0
     et compatibles avec l'iPhone choisi sont proposés. Aucune économie n'est affichée (pas de remise inventée). */
  var SLOTS = null, packEl = null;
  function freeTypes() { return String(CFG.free_types || CFG.coque_type || 'Coque iPhone').split(',').map(norm).filter(Boolean); }
  function isCoque(p) { var t = norm(p.product_type || p.type || ''); return t ? freeTypes().indexOf(t) > -1 : false; }
  function modelTags(p) { return (p.tags || []).filter(function (t) { return /^iphone\s/i.test(String(t).trim()); }).map(norm); }
  function setupPack(box) {
    packEl = box;
    var defs = (CFG.pack || []).filter(function (s) { return s && s.url; });
    if (!P || !isCoque(P) || !defs.length) { return; }
    Promise.all(defs.map(function (s) {
      return getJSON(s.url.replace(/\/$/, '') + '/products.json?limit=100').then(function (j) {
        var list = (j.products || []).filter(function (p) {
          if (isCoque(p)) { return false; }
          p.variants = (p.variants || []).filter(function (v) { return v.available && cents(v.price) > 0; });
          return p.variants.length > 0;
        });
        return { t: s.title, opt: !!s.optional, k: s.url, list: list };
      }).catch(function () { return { t: s.title, k: s.url, list: [] }; });
    })).then(function (r) { SLOTS = r; renderPack(); });
  }
  function compatible(list) {
    var mv = chosenModelValue(), want = mv ? norm('iPhone ' + mv) : '';
    return list.filter(function (p) { var mt = modelTags(p); return !mt.length || (want && mt.indexOf(want) > -1); });
  }
  function renderPack() {
    var box = packEl; if (!box || !SLOTS) { return; }
    var keep = {};
    qa(box, '[data-slot]').forEach(function (g) { var c = g.querySelector('input:checked'); if (c) { keep[g.getAttribute('data-slot')] = c.value; } });
    var groups = SLOTS.map(function (s) { return { s: s, list: compatible(s.list) }; }).filter(function (g) { return g.list.length; });
    if (!groups.length) { box.hidden = true; box.innerHTML = ''; return; }
    var mv = chosenModelValue();
    var html = '<h2 class="ecp-pack__t">Composez votre pack</h2><p class="ecp-pack__s">Votre coque' + (mv ? ' pour iPhone ' + esc(mv) : '') + ', puis les accessoires de votre choix. Chaque accessoire est facultatif.</p>';
    groups.forEach(function (g, gi) {
      var name = 'ecp-slot-' + gi, cur = keep[g.s.k] || '';
      html += '<fieldset class="ecp-pack__g" data-slot="' + esc(g.s.k) + '"><legend>' + esc(g.s.t) + (g.s.opt ? ' <span>(en option)</span>' : '') + '</legend><ul class="ecp-pack__list" role="list">';
      html += '<li class="ecp-pack__i"><label class="ecp-pack__lb"><input type="radio" name="' + name + '" value=""' + (cur ? '' : ' checked') + '><span class="ecp-pack__n">Sans ' + esc(g.s.t.toLowerCase()) + '</span></label></li>';
      g.list.forEach(function (p) {
        var img = p.images && p.images[0] ? p.images[0].src : '';
        p.variants.forEach(function (v) {
          var val = p.id + ':' + v.id, lab = p.title + (v.title && v.title !== 'Default Title' ? ' — ' + v.title : '');
          html += '<li class="ecp-pack__i"><label class="ecp-pack__lb"><input type="radio" name="' + name + '" value="' + val + '"' + (cur === val ? ' checked' : '') + '>' +
            (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="48" height="48" loading="lazy">' : '') +
            '<span class="ecp-pack__n">' + esc(lab) + '</span><span class="ecp-pack__p">+ ' + dh(cents(v.price)) + '</span></label></li>';
        });
      });
      html += '</ul></fieldset>';
    });
    html += '<p class="ecp-pack__tot">Total du pack : <b data-ecp-tot></b></p><p class="ecp-pack__ship">Livraison offerte : le pack contient une coque.</p><button type="button" class="ecp-pack__add" data-ecp-pack-add>Ajouter le pack au panier</button><p class="ecp-pack__m" data-ecp-pack-msg role="status" aria-live="polite"></p>';
    box.innerHTML = html; box.hidden = false; packTotal();
  }
  function packSel() {
    var out = [];
    qa(packEl, '[data-slot]').forEach(function (g) {
      var c = g.querySelector('input:checked'); if (!c || !c.value) { return; }
      var ids = c.value.split(':'), slot = (SLOTS || []).filter(function (s) { return s.k === g.getAttribute('data-slot'); })[0]; if (!slot) { return; }
      var p = slot.list.filter(function (x) { return String(x.id) === ids[0]; })[0], v = p && p.variants.filter(function (x) { return String(x.id) === ids[1]; })[0];
      if (p && v) { out.push({ p: p, v: v }); }
    });
    return out;
  }
  function packTotal() {
    if (!packEl || packEl.hidden || !P) { return; }
    var v = variantById(variantId(productForm()));
    var tot = (v ? v.price : P.price) * quantity();
    packSel().forEach(function (x) { tot += cents(x.v.price); });
    var n = packEl.querySelector('[data-ecp-tot]'), s = dh(tot); if (n && n.textContent !== s) { n.textContent = s; }
  }
  d.addEventListener('change', function (e) { if (packEl && e.target && packEl.contains(e.target)) { packTotal(); } else if (packEl && e.target && e.target.matches && e.target.matches('#MainContent input[name="quantity"]')) { packTotal(); } });
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ecp-pack-add]') : null; if (!b || !P) { return; }
    var msg = packEl.querySelector('[data-ecp-pack-msg]'); msg.textContent = '';
    var miss = missingOptions(); if (miss.length) { showMiss(msg, miss); return; }
    var v = variantById(variantId(productForm()));
    if (!v || !v.available) { msg.textContent = 'Cette version de la coque est épuisée : choisissez une autre couleur.'; return; }
    var items = [{ id: v.id, quantity: quantity() }], mv = chosenModelValue();
    packSel().forEach(function (x) { var it = { id: x.v.id, quantity: 1 }; if (mv && modelTags(x.p).length) { it.properties = { 'Modèle iPhone': 'iPhone ' + mv }; } items.push(it); });
    b.setAttribute('aria-busy', 'true');
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { throw new Error(j.description || j.message || ''); } }); })
      .then(function () { location.href = ROOT + 'cart'; })
      .catch(function (err) { b.removeAttribute('aria-busy'); msg.textContent = (err && err.message) || 'L’ajout n’a pas abouti. Veuillez réessayer.'; });
  });

  /* ===== 12. Récemment consultés : uniquement après la consultation d'autres fiches (stocké sur cet appareil) ===== */
  var REC = 'ec-recent';
  function readRecent() { try { var a = JSON.parse(W.localStorage.getItem(REC) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function pushRecent(p) {
    if (!p || !p.handle) { return; }
    var a = readRecent().filter(function (x) { return x && x.h !== p.handle; });
    var img = p.featured_image || (p.images && p.images[0]) || '';
    a.unshift({ h: p.handle, t: p.title, i: typeof img === 'string' ? img : (img.src || ''), p: p.price, c: p.compare_at_price || 0 });
    try { W.localStorage.setItem(REC, JSON.stringify(a.slice(0, 12))); } catch (e) {}
  }
  function renderRecent(excl) {
    if (PT !== 'product' && PT !== 'index' && PT !== 'collection' && PT !== 'cart') { return; }
    var list = readRecent().filter(function (x) { return x && x.h && x.h !== excl; }).slice(0, 8);
    var old = d.querySelector('[data-ecp-recent]'); if (old) { old.parentNode.removeChild(old); }
    if (!list.length || !MAIN) { return; }
    var sec = el('section', 'ecp-rec'); sec.setAttribute('data-ecp-recent', ''); sec.setAttribute('aria-label', 'Récemment consultés');
    var h = '<div class="ecp-rec__in"><div class="ecp-rec__hd"><h2 class="ecp-rec__t">Récemment consultés</h2><button type="button" class="ecp-rec__x" data-ecp-recent-clear>Effacer</button></div><ul class="ecp-rec__row" role="list">';
    list.forEach(function (x) {
      var img = x.i ? (x.i.indexOf('//') === 0 ? 'https:' + x.i : x.i) : '';
      h += '<li><a class="ecp-rec__c" href="' + esc(ROOT + 'products/' + x.h) + '">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="" width="150" height="150" loading="lazy">' : '<span class="ecp-rec__ph"></span>') +
        '<span class="ecp-rec__n">' + esc(x.t) + '</span><span class="ecp-rec__p">' + (x.c > x.p ? '<s>' + dh(x.c) + '</s> ' : '') + dh(x.p) + '</span></a></li>';
    });
    sec.innerHTML = h + '</ul></div>';
    var foot = d.querySelector('#MainContent > .shopify-section:last-child, #MainContent > *:last-child');
    MAIN.appendChild(sec);
    if (foot && foot.querySelector && foot.querySelector('.lrv')) { MAIN.insertBefore(sec, foot); }
  }
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ecp-recent-clear]') : null; if (!b) { return; }
    try { W.localStorage.removeItem(REC); } catch (x) {}
    var s = b.closest('[data-ecp-recent]'); if (s) { s.parentNode.removeChild(s); }
  });

  /* ===== Panier : livraison claire, WhatsApp, panier conservé, accessoires compatibles ===== */
  var CART = null;
  /* Règle : livraison offerte dès qu'une coque (type de produit réel, ex. « Coque iPhone » ou « Pack ») est dans le panier ;
     accessoires seuls : frais réglés dans la section (35 DH). Indicatif : le montant facturé vient des tarifs d'expédition Shopify. */
  function hasCoque(cart) { var ft = freeTypes(); return (cart.items || []).some(function (i) { return ft.indexOf(norm(i.product_type || '')) > -1; }); }
  function shipping(cart) {
    if (!cart || !cart.item_count || hasCoque(cart)) { return 0; }
    return Math.round(Number(CFG.ship_fee || 0) * 100);
  }
  function setupCart() {
    if (PT !== 'cart') { return; }
    getJSON(ROOT + 'cart.js').then(function (cart) {
      CART = cart; renderCartInfo(); checkCartChanges(cart); filterCartAccessories();
    }).catch(function () {});
    d.addEventListener('lt:cart-changed', refreshCart);
    if (W.MutationObserver && MAIN) { new MutationObserver(function () { W.clearTimeout(setupCart.t); setupCart.t = W.setTimeout(function () { if (!d.querySelector('[data-ecp-ship]')) { renderCartInfo(); } filterCartAccessories(); }, 120); }).observe(MAIN, { childList: true, subtree: true }); }
    d.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('cart-items-component,.cart-items')) { W.setTimeout(refreshCart, 900); } });
    d.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('cart-items-component button,.cart-items button')) { W.setTimeout(refreshCart, 900); } });
  }
  function refreshCart() { getJSON(ROOT + 'cart.js').then(function (c) { CART = c; renderCartInfo(); saveSnap(c, true); filterCartAccessories(); }).catch(function () {}); }
  function renderCartInfo() {
    var cart = CART; if (!cart) { return; }
    var inner = d.querySelector('#MainContent .cart-summary__inner'); if (!inner) { return; }
    var box = inner.querySelector('[data-ecp-ship]');
    if (!cart.item_count) { if (box) { box.parentNode.removeChild(box); } return; }
    if (!box) { box = el('div', 'ecp-ship'); box.setAttribute('data-ecp-ship', ''); inner.insertBefore(box, inner.firstChild); }
    var fee = shipping(cart), total = cart.total_price + fee;
    box.innerHTML = '<h2 class="ecp-ship__t">Récapitulatif</h2><dl class="ecp-ship__dl">' +
      '<div><dt>Sous-total</dt><dd>' + dh(cart.total_price) + '</dd></div>' +
      '<div><dt>Livraison</dt><dd>' + (fee ? dh(fee) : 'Offerte') + '</dd></div>' +
      '<div class="ecp-ship__tot"><dt>Total avec livraison</dt><dd>' + dh(total) + '</dd></div>' +
      (CFG.delay ? '<div><dt>Délai estimé</dt><dd>' + esc(CFG.delay) + '</dd></div>' : '') +
      (CFG.zone ? '<div><dt>Zone</dt><dd>' + esc(CFG.zone) + '</dd></div>' : '') +
      (CFG.payment ? '<div><dt>Paiement</dt><dd>' + esc(CFG.payment) + '</dd></div>' : '') + '</dl>' +
      (!hasCoque(cart) ? '<p class="ecp-ship__up">Ajoutez une coque pour bénéficier de la livraison offerte.' + (CFG.all_url ? ' <a href="' + esc(CFG.all_url) + '">Voir les coques</a>' : '') + '</p>' : '') +
      (CFG.rule ? '<p class="ecp-ship__r">' + esc(CFG.rule) + '</p>' : '') +
      (WA ? '<button type="button" class="ecp-wa__b ecp-wa__b--cart" data-ecp-wa-cart><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12.04 2a9.9 9.9 0 0 0-8.5 14.9L2 22l5.25-1.38A9.9 9.9 0 1 0 12.04 2zm0 1.8a8.1 8.1 0 1 1-4.17 15.05l-.3-.18-3.1.82.83-3.03-.2-.31A8.1 8.1 0 0 1 12.04 3.8z"/></svg>Commander sur WhatsApp</button>' : '');
  }
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ecp-wa-cart]') : null; if (!b) { return; }
    e.preventDefault();
    getJSON(ROOT + 'cart.js').then(function (cart) {
      if (!cart.item_count) { return; }
      var fee = shipping(cart), L = ['Bonjour Elegance Coque, je souhaite commander :', ''];
      cart.items.forEach(function (it, n) {
        L.push((n + 1) + '. ' + it.product_title);
        (it.options_with_values || []).forEach(function (o) { if (o.value && o.value !== 'Default Title') { L.push('   ' + o.name + ' : ' + (o.name === MODEL_OPT ? 'iPhone ' + o.value : o.value)); } });
        var pr = it.properties || {}; Object.keys(pr).forEach(function (k) { if (pr[k] && k.charAt(0) !== '_') { L.push('   ' + k + ' : ' + pr[k]); } });
        L.push('   Quantité : ' + it.quantity + ' · Prix : ' + dh(it.final_line_price));
        L.push('   ' + absUrl(it.url));
      });
      L.push('', 'Sous-total : ' + dh(cart.total_price), 'Livraison : ' + (fee ? dh(fee) : 'offerte'), 'Total : ' + dh(cart.total_price + fee), '', 'Merci de me confirmer la commande.');
      waOpen(L.join('\n'));
    }).catch(function () {});
  });

  /* 10. Panier conservé : Shopify garde le panier dans ce navigateur ; on signale tout changement de prix ou de disponibilité */
  var SNAP = 'ec-cart-snap';
  function readSnap() { try { return JSON.parse(W.localStorage.getItem(SNAP) || 'null'); } catch (e) { return null; } }
  function saveSnap(cart, replace) {
    var old = readSnap(), items = {};
    if (!replace && old && old.token === cart.token) { items = old.items || {}; }
    (cart.items || []).forEach(function (i) { if (replace || !items[i.key]) { items[i.key] = { p: i.final_price, t: i.title }; } });
    try { W.localStorage.setItem(SNAP, JSON.stringify({ token: cart.token, items: items })); } catch (e) {}
  }
  function checkCartChanges(cart) {
    var old = readSnap(), msgs = [];
    if (old && old.token === cart.token) {
      (cart.items || []).forEach(function (i) { var o = old.items && old.items[i.key]; if (o && o.p !== i.final_price) { msgs.push('Le prix de « ' + i.title + ' » est passé de ' + dh(o.p) + ' à ' + dh(i.final_price) + '.'); } });
    }
    var handles = {}; (cart.items || []).forEach(function (i) { handles[i.handle] = 1; });
    Promise.all(Object.keys(handles).map(function (h) { return getJSON(ROOT + 'products/' + h + '.js').catch(function () { return null; }); })).then(function (ps) {
      var vmap = {}; ps.forEach(function (p) { if (p) { (p.variants || []).forEach(function (v) { vmap[v.id] = v; }); } });
      (cart.items || []).forEach(function (i) { var v = vmap[i.variant_id]; if (v && !v.available) { msgs.push('« ' + i.title + ' » n’est plus disponible. Retirez-le ou choisissez une autre couleur pour le même iPhone.'); } });
      if (msgs.length) {
        var box = el('div', 'ecp-notice'); box.setAttribute('role', 'alert');
        box.innerHTML = '<p class="ecp-notice__t">Votre panier a été mis à jour</p><ul>' + msgs.map(function (m) { return '<li>' + esc(m) + '</li>'; }).join('') + '</ul>';
        var at = d.querySelector('#MainContent cart-items-component') || d.querySelector('#MainContent .shopify-section');
        if (at) { at.parentNode.insertBefore(box, at); }
      }
      saveSnap(cart, true);
    });
  }
  function snapOnBrowse() {
    if (PT === 'cart') { return; }
    var c = d.querySelector('[data-lt-cart-count]'); if (!c || !(parseInt(c.textContent, 10) > 0)) { return; }
    getJSON(ROOT + 'cart.js').then(function (cart) { saveSnap(cart, false); }).catch(function () {});
  }

  /* 7. Accessoires du panier : seulement ceux compatibles avec l'iPhone des coques du panier, modèle pré-choisi */
  function filterCartAccessories() {
    if (!CART) { return; }
    var models = {};
    (CART.items || []).forEach(function (i) { (i.options_with_values || []).forEach(function (o) { if (o.name === MODEL_OPT && o.value) { models[norm('iPhone ' + o.value)] = 'iPhone ' + o.value; } }); });
    var keys = Object.keys(models); if (!keys.length) { return; }
    qa(d, '[data-lca-card]').forEach(function (card) {
      var sel = card.querySelector('[data-lca-model]'); if (!sel) { return; }
      var match = [].filter.call(sel.options, function (o) { return o.value && keys.indexOf(norm(o.value)) > -1; });
      card.classList.toggle('ecp-out', !match.length);
      if (match.length === 1 && !sel.value) { sel.value = match[0].value; }
    });
  }

  /* ===== 14. Accès Accueil et Mes favoris dans le menu mobile ; favoris chargés partout ===== */
  function drawerLinks() {
    var ul = d.querySelector('.lt-drawer__panel ul'); if (!ul || ul.__ecp) { return; }
    ul.__ecp = true;
    var hasHome = qa(ul, 'a').some(function (a) { try { return new URL(a.href, location.href).pathname === ROOT; } catch (e) { return false; } });
    if (!hasHome) { var li = el('li', 'ecp-home', '<a href="' + ROOT + '"' + (PT === 'index' ? ' aria-current="page" class="is-current"' : '') + '>Accueil</a>'); ul.insertBefore(li, ul.firstChild); }
    var fav = CFG.fav_url || ROOT + 'pages/favoris';
    var hasFav = qa(ul, 'a').some(function (a) { return a.getAttribute('href') === fav; });
    if (!hasFav) { var lf = el('li', '', '<a href="' + esc(fav) + '">Mes favoris</a>'); var acc = qa(ul, 'li').pop(); ul.insertBefore(lf, acc || null); }
  }
  function ensureWishlist() {
    if (W.LuxeWishlist || d.querySelector('script[src*="luxe-wishlist"]') || !CFG.wishlist_js) { return; }
    if (!d.getElementById('lwl-config')) { var c = el('script'); c.type = 'application/json'; c.id = 'lwl-config'; c.textContent = JSON.stringify({ page: CFG.fav_url || '/pages/favoris', money: CFG.money || '{{amount}} DH' }); d.head.appendChild(c); }
    var s = el('script'); s.src = CFG.wishlist_js; s.defer = true; d.head.appendChild(s);
  }

  /* ---------- démarrage ---------- */
  function boot() {
    ensureWishlist(); drawerLinks();
    restoreModel(); renderBar();
    addHelpLinks(); setupFilters();
    setupProduct(); setupCart(); snapOnBrowse();
    if (PT !== 'product') { renderRecent(''); }
  }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  W.addEventListener('pageshow', function (e) { if (e.persisted) { renderBar(); refreshFilters(); } });
  d.addEventListener('shopify:section:load', function () { W.setTimeout(function () { addHelpLinks(); setupFilters(); renderBar(); }, 60); });
  W.ECParcours = { readModel: readModel, saveModel: saveModel, openHelp: openHelp };
})();
